import { useNavigationParams } from '../system/useNavigationParams'
import { ServerServices } from '../uiModels/openApiServices'

export type StandardServicesType =
  | typeof ServerServices.collCalc
  | typeof ServerServices.life
  | typeof ServerServices.legalEntity
  | typeof ServerServices.unitLink
  | typeof ServerServices.moneyIn
  | typeof ServerServices.moneyOut

/** Helper hook used to retrieve the current OpenAPI specification based on the currently active server. Astracts the
 * standard component services and the configuration component services into a common API. */
export const useStandardService = (): StandardServicesType => {
  const { server } = useNavigationParams()

  if (!server || !ServerServices[server]) {
    throw new Error(`Unknown server: ${server}`)
  }

  return ServerServices[server]
}
